import React, { useContext } from "react";
import { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import TableFooter from "../../components/TableFooter";
import SearchTopBar from "../../components/SearchTopBar";
import { decryptText } from "../../utils/cipherText";
import ImageLoading from "../../components/ImageLoading";
import NotFoundImage from "../../images/NotFoundImage";
import NoDataFound from "../../components/NoDataFound";
import NoSearchitems from "../../components/NoSearchitems";
import { IoArrowUpSharp } from "react-icons/io5";
import all from "../../images/all.png";
import desc from "../../images/desc.png";
import asc from "../../images/asc.png";
import { CgArrowUp, CgArrowDown } from "react-icons/cg";
import { TbFilterX } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { formatToIndianRupees, truncateText } from "../../utils/handlers";

///table Imports
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import TableComponent from "../../components/TableComponent";
import { sideBarContext } from "../../App";

const SortTableHeader = ({
  title,
  handleSort,
  sortBy,
  sortType,
  param,
  setSortBy,
  setSortType,
  setOpenSorting,
  openSorting,
}) => {
  return (
    <button
      className=" flex items-center relative"
      onClick={() => {
        if (sortType !== param) {
          setSortBy("");
          setSortType(param);
        }

        if (!openSorting || sortType !== param) {
          setOpenSorting(true);
        } else if (openSorting && sortType === param) {
          setOpenSorting(false);
        }
      }}
    >
      {" "}
      {openSorting && sortType === param && (
        <div
          className={`w-[162px] px-2 rounded-lg absolute z-[11] bg-white top-6 text-xs font-medium shadow-md py-2 right-[2px]`}
        >
          <div
            className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
              sortBy === "asc" && "bg-[#A0FF77]"
            }`}
            onClick={() => {
              setSortBy("asc");
              setOpenSorting(false);
            }}
          >
            <CgArrowUp size={"15px"} /> Sort Ascending
          </div>
          <div
            className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] mt-2 pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
              sortBy === "desc" && "bg-[#A0FF77]"
            }`}
            onClick={() => {
              setSortBy("desc");
              setOpenSorting(false);
            }}
          >
            <CgArrowDown size={"15px"} /> Sort Descending
          </div>
          {sortBy && (
            <div className="flex flex-row justify-center items-center w-full">
              <button
                type="button"
                className="py-[3px] px-2 rounded w-[73px] h-6 font-medium  text-[#00394d] border border-[#00394d] mt-3 flex flex-row justify-center items-center gap-2"
                onClick={() => {
                  setSortBy("");
                  setSortType("");
                  setSortType("");
                  setOpenSorting(false);
                }}
              >
                <TbFilterX size={"15px"} /> Clear
              </button>
            </div>
          )}
        </div>
      )}
      <p className="flex items-center text-left">{title}</p>
      <span
        className={`ml-1 ${
          sortType === param && sortBy !== ""
            ? "visible !opacity-100"
            : "visible"
        }`}
      >
        {sortType === param && sortBy === "asc" ? (
          <img src={asc} alt="sort" className="" />
        ) : sortType === param && sortBy === "desc" ? (
          <img src={desc} alt="sort" className="" />
        ) : (
          <img src={all} alt="sort" className="" />
        )}
      </span>
    </button>
  );
};

function Odtransactions() {
  const navigate = useNavigate();
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [list, setList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [id, setId] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(rowsPerPage);
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [totalRows, setTotalRows] = useState();
  const [searchPages, setSearchPages] = useState();
  const [searchRows, setSearchRows] = useState();
  const [filterShow, setFilterShow] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("name");
  // const [searchQuery, setSearchQuery] = useState("");

  const [transactionShow, setTransactionShow] = useState([]);
  const [transactionShowText, setTransactionShowText] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState("executed");
  const [imageLoading, setImageLoading] = useState(false);
  const [searchEmpty, setSearchEmpty] = useState(false);
  const storedSearch = "";
  const [searchQuery, setSearchQuery] = React.useState(storedSearch);
  const [optionSelected, setOptionSelected] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [emiValue, setEmiValue] = useState("");
  const sortStates = ["", "asc", "desc"];
  const [sortType, setSortType] = useState("");
  const [sortBy, setSortBy] = useState(sortStates[0]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [openSorting, setOpenSorting] = useState(false);
  const [message, setMessage] = useState("");
  const [switchOd, setSwitchOd] = useState(true);
  const [type, setType] = useState("all");
  const [imageLoadingInside, setImageLoadingInside] = useState(false);
  ///table States
  const columnHelper = createColumnHelper();
  const [leafColumns, setLeafColumns] = useState([]);
  const [columnSettings, setColumnSettings] = useState(false);
  const [loanType, setLoanType] = useState("");
  const { expanded } = useContext(sideBarContext);

  const columns = [
    columnHelper.accessor((row, index) => index + 1, {
      id: "index",
      cell: (info) => info.row.index + 1 + startIndex,
      header: () => "#",
      static: true,
      enableHiding: false,
      enableSorting: false,
      size: 40,
    }),
    columnHelper.accessor("date", {
      id: "Date",
      cell: (info) => info.getValue(),
      header: () => "Date",
      enableSorting: false,
      enableHiding: false,
    }),
    columnHelper.accessor("amount_type", {
      id: "Type",
      cell: (info) => (
        <span
          className={` ${
            info.getValue() === "credit"
              ? "bg-[#F0FDF4] text-[#188240] border-[#C4EBD2] border-[0.5px] capitalize"
              : "bg-[#FDF0F0] text-[#C33D3D] border-[#EBC4C4] border-[0.5px] capitalize"
          } rounded-full cursor-default px-2 py-[2px] text-xs font-medium`}
        >
          {info.getValue() || "--"}
        </span>
      ),
      header: () => "Type",
      enableSorting: false,
      enableHiding: false,
    }),

    columnHelper.accessor("amount_paid", {
      id: "Amount Paid",
      cell: (info) => formatToIndianRupees(info.getValue()),
      header: () => "Amount Paid",
      enableSorting: false,
      enableHiding: false,
    }),
    columnHelper.accessor("name", {
      id: "UserName",
      cell: (info) => truncateText(info.getValue(), 18),
      header: () => "UserName",
      enableSorting: false,

      size: 190,
    }),
    columnHelper.accessor("bajaj_loan_no", {
      id: "Loan Number",
      cell: (info) => info.getValue(),
      header: () => "Loan Number",
      enableSorting: false,
      size: 170,
    }),
    columnHelper.accessor("tenure", {
      id: "Tenure",
      cell: (info) => info.getValue(),
      header: () => "Tenure",
      enableSorting: false,
      size: 100,
    }),
    columnHelper.accessor("outstanding_balance", {
      id: "Outstanding",
      cell: (info) => formatToIndianRupees(info.getValue()),
      header: () => "Outstanding",
      enableSorting: false,
    }),
    columnHelper.accessor("od_limit", {
      id: "OD Limit",
      cell: (info) => formatToIndianRupees(info.getValue()),
      header: () => "OD Limit",
      enableSorting: false,
    }),
    columnHelper.accessor("transaction_type", {
      id: "Transaction Type",
      cell: (info) => info.getValue(),
      header: () => "Transaction Type",
      enableSorting: false,
    }),
    columnHelper.accessor("transaction_status", {
      id: "Transaction Status",
      cell: (info) => (
        <span
          className={` ${
            info.getValue() === "success"
              ? "bg-[#F0FDF4] text-[#188240] border-[#C4EBD2] border-[0.5px]"
              : "bg-[#FDF0F0] text-[#C33D3D] border-[#EBC4C4] border-[0.5px] capitalize"
          } rounded-full cursor-default px-2 py-[2px] text-xs font-medium`}
        >
          {info.getValue() || "--"}
        </span>
      ),
      header: () => "Transaction Status",
      enableSorting: false,
      size: 155,
    }),
  ];

  const [visibleColumns, setVisbleColumns] = useState(
    localStorage.getItem("odTransactionsTableData")
      ? JSON.parse(localStorage.getItem("odTransactionsTableData")).visible
      : {}
  );

  //////
  const [columnOrder, setColumnOrder] = useState(() =>
    localStorage.getItem("odTransactionsTableData")
      ? JSON.parse(localStorage.getItem("odTransactionsTableData")).order
      : columns.map((c) => c.id)
  );

  const fetchOrders = async () => {
    setImageLoading(true);

    const token = localStorage.getItem("token");
    let url = `${process.env.REACT_APP_URL}/lender/v1/transactions?page=${pageNo}&per_page=${rowsPerPage}&filters=${searchQuery}`;
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(url, options);
      if (res.data) {
        setTotalRows(res.data.total_records);
        setTotalPages(res.data.total_page_count);
        setList(res.data.transaction_data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [searchQuery, pageNo, rowsPerPage]);

  const displayedRows = list;
  const noOfRows = totalRows;
  const noOfPages = totalPages;

  const handleClick = async () => {
    setTransactionShow([]);
    if (id !== "") {
      setImageLoadingInside(true);
      const token = localStorage.getItem("token");
      let options;
      if (switchOd) {
        options = {
          headers: {
            Authorization: token,
          },
          url: `${process.env.REACT_APP_URL}/lender/v1/transactions/${id}`,
          method: "GET",
        };
      }
      try {
        const response = await axios(options);
        setTransactionShow(response.data.transaction_data);
      } catch (error) {
        setTransactionShow([]);
      } finally {
      }
    }
  };
  const clickFunction = (singleRow) => {
    if (userType !== "distributors") {
      setSwitchOd(true);
      setId(singleRow.bajaj_loan_no);
      setTransactionShowText(true);
      setMessage(singleRow);
    }
  };

  useEffect(() => {
    handleClick();
  }, [id, selectedPayment, switchOd]);

  const filterList = ["name"];

  const alterStatus = (inputString) => {
    if (inputString === "INITIATED") {
      return "pending";
    } else {
      return inputString?.replace(/_/g, " ").toLowerCase();
    }
  };
  const handleSort = (type) => {
    let byValue = sortStates[(sortStates.indexOf(sortBy) + 1) % 3];

    if (sortType === type && byValue === "") {
      setSortType("");
      setSortBy(byValue);
      return;
    }
    if (sortType !== type) {
      byValue = "asc";
      setSortBy(byValue);
      setSortType(type);
      return;
    }

    setSortBy(byValue);
  };
  const [tempVisibility, setTempVisibility] = useState({
    ...visibleColumns,
  });

  const TYPE_COLORS = {
    repayment: { border: "#26a69a", text: "#26a69a" },
    refund: { border: "#ff4500", text: "#ff4500" },
    interest: { border: "#00ACD2", text: "#00ACD2" },
    principal: { border: "#8826AB", text: "#8826AB" },
    default: { border: "#BDAB00", text: "#BDAB00" },
  };

  const getTypeColor = (type) => {
    if (typeof type !== "string") return { border: "#BDAB00", text: "#BDAB00" };
    const { border, text } = TYPE_COLORS[type] || TYPE_COLORS.default;
    return { border: border, text: text };
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      try {
        localStorage.setItem(
          "odTransactionsTableData",
          JSON.stringify({
            order: columnOrder,
            visible: visibleColumns,
          })
        );
      } catch (error) {
        console.error("Failed to save table data to localStorage:", error);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [visibleColumns, columnOrder]);

  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);
  return (
    <div
      className={`${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] h-[100vh] px-[20px] pt-[16px]`}
    >
      <div className="mt-4 rounded-lg bg-white mb-4 p-4">
        <p className="text-[#262626] text-xl font-semibold">
          Repayment Overdraft
        </p>
      </div>
      {!transactionShowText ? (
        <>
          <div className=" bg-white px-4 flex flex-col justify-between pt-2 rounded-t-lg">
            <SearchTopBar
              setPageNo={setPageNo}
              od={true}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              filterList={filterList}
              filterShow={filterShow}
              setFilterShow={setFilterShow}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
              downloadPageWord="transactions"
              optionSelected={optionSelected}
              setOptionSelected={setOptionSelected}
              statusFilter={statusFilter}
              setStatusFilter={setStatusFilter}
              triggerFilter={triggerFilter}
              setTriggerFilter={setTriggerFilter}
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setEmiValue={setEmiValue}
              emiValue={emiValue}
              filterApplied={filterApplied}
              setFilterApplied={setFilterApplied}
              tempVisibility={tempVisibility}
              setTempVisibility={setTempVisibility}
              setVisibleColumns={setVisbleColumns}
              leafColumns={leafColumns}
              columnSettings={columnSettings}
              setColumnSettings={setColumnSettings}
            />
          </div>
          <div className="pt-2 w-full bg-white">
            {imageLoading && (
              <div className="w-full h-[calc(100vh-245px)] flex items-center justify-center">
                <ImageLoading />
              </div>
            )}
            {!imageLoading && (
              <>
                {/* <div className="flex items-center text-sm gap-8 px-4">
                  <p
                    className={`${
                      type === "all"
                        ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                        : "font-medium"
                    } py-2 cursor-pointer text-[#262626] text-sm`}
                    onClick={() => {
                      setType("all");
                    }}
                  >
                    All
                  </p>
                  <p
                    className={`${
                      type === "term"
                        ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                        : "font-medium"
                    } py-2 cursor-pointer text-[#262626] text-sm`}
                    onClick={() => {
                      setType("term");
                    }}
                  >
                    Term Loan
                  </p>
                  <p
                    className={`${
                      type === "od"
                        ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                        : "font-medium"
                    } py-2 cursor-pointer text-[#262626] text-sm`}
                    onClick={() => {
                      setType("od");
                    }}
                  >
                    Overdraft Loan
                  </p>
                </div> */}
                <div className=" overflow-auto mx-4 mt-2 enable-scrollbar-x">
                  <TableComponent
                    list={displayedRows}
                    imageLoading={imageLoading}
                    columns={columns}
                    visibleColumns={visibleColumns}
                    setLeafColumns={setLeafColumns}
                    handleClick={clickFunction}
                    columnOrder={columnOrder}
                    setColumnOrder={setColumnOrder}
                    pinnedColumns={["index", "Date", "Type", "Amount Paid"]}
                    setColumnSettings={setColumnSettings}
                  />
                </div>
              </>
            )}
          </div>
          <TableFooter
            totalPages={noOfPages}
            totalRows={noOfRows}
            rowsPerPage={rowsPerPage}
            startIndex={startIndex}
            setStartIndex={setStartIndex}
            setEndIndex={setEndIndex}
            endIndex={endIndex}
            setPageNo={setPageNo}
            pageNo={pageNo}
            setRowsPerPage={setRowsPerPage}
          />
        </>
      ) : (
        <>
          <div className="mt-4 rounded-lg bg-white mb-4 p-4">
            <p className=" text-sm">
              <span
                className="cursor-pointer hover:underline transition ease-in-out duration-500 hover:font-medium"
                onClick={() => setTransactionShowText(false)}
              >
                {" "}
                List of Users{" "}
              </span>
              <span className=" font-bold text-base text-[#262626]">
                {" "}
                &gt; {message?.name || "---"}{" "}
              </span>
            </p>
          </div>
          <div className="pt-1 w-full bg-white pl-[20px]">
            <div className="rounded-[23px] bg-[#F0F0F0] text-sm font-semibold text-[#000000] p-1 inline-block">
              {message?.od_order && (
                <button
                  className={`${
                    switchOd ? "bg-[#92e86c]" : ""
                  } w-[180px] py-[7px] rounded-[19px]`}
                  onClick={() => setSwitchOd(true)}
                >
                  Overdraft Loan
                </button>
              )}
            </div>
            {switchOd ? (
              <table
                className={`box-border h-full flex flex-col enable-scrollbar   ${
                  transactionShow?.length ? "w-full" : ""
                }`}
              >
                <thead className="text-sm font-semibold h-full w-full">
                  <tr className="w-full flex items-center justify-between py-2">
                    <th className={`text-left text-sm font-semibold w-[16%]`}>
                      Date
                    </th>
                    <th className={`text-left text-sm font-semibold w-[22%]`}>
                      Transaction ID
                    </th>
                    <th className={`text-left text-sm font-semibold w-[13%]`}>
                      Type
                    </th>
                    <th className={`text-left text-sm font-semibold w-[20%]`}>
                      Amount paid (&#8377;)
                    </th>
                    <th className={`text-left text-sm font-semibold w-[20%]`}>
                      Transaction Type
                    </th>
                    <th className={`text-left text-sm font-semibold w-[17%]`}>
                      Transaction Status
                    </th>
                  </tr>
                </thead>
                {transactionShow?.length ? (
                  <tbody
                    className={`overflow-auto max-h-[calc(100vh-255px)] ${
                      transactionShow?.transaction_details?.length === 0
                        ? "h-[calc(100vh-330px)]"
                        : ""
                    }`}
                  >
                    {transactionShow?.length > 0 &&
                      transactionShow?.map((transaction, index) => {
                        const typeColor = getTypeColor(
                          transaction?.transaction_type
                        );
                        return (
                          <tr
                            key={index}
                            className={`w-full flex items-center py-4 justify-between`}
                          >
                            <td
                              className={`text-left text-xs font-medium w-[16%]`}
                            >
                              {transaction.date || "---"}
                            </td>
                            <td
                              className={`text-left text-xs font-medium w-[22%]  pr-[2%] `}
                            >
                              {transaction.uuid || "---"}
                            </td>
                            <td
                              className={`text-left text-xs font-medium w-[13%]`}
                            >
                              {transaction?.amount_type || "---"}
                            </td>
                            <td
                              className={`text-left text-xs font-medium w-[20%] ${
                                transaction.amount_type === "credit"
                                  ? "text-[#0ba300]"
                                  : "text-[#d30d00]"
                              }`}
                            >
                              {formatToIndianRupees(transaction.amount_paid) ||
                                "---"}
                            </td>
                            <td
                              className={`text-left text-xs font-medium w-[20%]`}
                            >
                              <span
                                style={{
                                  border: `1px solid ${typeColor.border}`,
                                  color: typeColor.text,
                                }}
                                className={` border border-solid px-2 py-1 rounded-full cursor-default capitalize flex items-center justify-center w-fit
                              `}
                              >
                                {transaction?.transaction_type || "---"}
                              </span>
                            </td>
                            <td
                              className={`text-left text-xs font-medium w-[17%]`}
                            >
                              <span
                                className={`
                                ${
                                  transaction?.transaction_status?.toLowerCase() ===
                                  "failed"
                                    ? "red-status"
                                    : transaction?.transaction_status?.toLowerCase() ===
                                      "initiated"
                                    ? "blue-status"
                                    : transaction?.transaction_status?.toLowerCase() ===
                                      "success"
                                    ? "green-status"
                                    : "blue-status"
                                } px-2 py-1 rounded-full cursor-default capitalize flex items-center justify-center w-fit
                              `}
                              >
                                {alterStatus(transaction.transaction_status)}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                ) : transactionShow.length === 0 && !imageLoadingInside ? (
                  <NoDataFound insidePage={true} />
                ) : imageLoadingInside ? (
                  <div className=" w-full h-[calc(100vh-260px)] flex justify-center items-center">
                    <ImageLoading />
                  </div>
                ) : (
                  <></>
                )}
              </table>
            ) : (
              <></>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default Odtransactions;
